import { render, staticRenderFns } from "./AddBankPosTerminal.vue?vue&type=template&id=06596264&"
import script from "./AddBankPosTerminal.vue?vue&type=script&lang=js&"
export * from "./AddBankPosTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports